<template>
  <a-result
    status="404"
    title="404"
    sub-title="抱歉，您要访问的页面不存在。请检查您的地址是否正确。"
  >
    <template #extra>
      <a-button type="primary" @click="backHome">回到首页</a-button>
    </template>
  </a-result>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    backHome() {
      this.$router.push("/");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/404.vue